module.exports = __webpack_public_path__ + "vue/img/doc-02.ca2d10eb.png";